import { useSearchParams } from 'react-router';
import { useAppLocation } from '#hooks/useAppLocation.ts';

export function useCameFromEndpoint() {
  const location = useAppLocation();
  const from = location.state?.from;
  const [fromParams] = useSearchParams(from?.search);
  return fromParams.get('tab') === 'endpoint';
}
